import {
	FETCH_EVENT_CHECKIN,
	UPDATE_EVENT_CHECKIN,
	CREATE_EVENT_CHECKIN,
} from '../actions/actionTypes';

const preState = { eventCheckin: null, attendeeCheckins: {} };

const checkinsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventCheckin } = action;

	switch (type) {
		case FETCH_EVENT_CHECKIN:
			return { ...stateDup, eventCheckin };
		case UPDATE_EVENT_CHECKIN:
			return { ...stateDup, eventCheckin };
		case CREATE_EVENT_CHECKIN:
			return { ...stateDup, eventCheckin };
		default:
			return stateDup;
	}
};

export default checkinsReducer;
